import { createContext, useRef } from "react";

export const shoppingCartRef = createContext<React.RefObject<HTMLDivElement> | null>(null);

export const RefContextStore = (props: { children?: JSX.Element | JSX.Element[] | null }) => {
  const ref = useRef<HTMLDivElement>(null);
  return <shoppingCartRef.Provider value={ref}>{props.children}</shoppingCartRef.Provider>;
};
